import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type PagerdutyConnectorConfig = typeof PagerdutyConnector._.Config;

export const PagerdutyConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Pagerduty,
  logoPath: 'images/pagerduty-logo.svg',
  categories: [IntegrationConnectorCategory.Monitoring, IntegrationConnectorCategory.ITSM],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AppOauthClientCredentials,
      configSchema: z.object({
        region: z.enum(['us', 'eu']),
        subdomain: z
          .string()
          .trim()
          .min(1)
          .max(63)
          .regex(
            /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i,
            'PagerDuty subdomain must contain only letters, numbers, and internal hyphens',
          ),
        clientId: z.uuid(),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
  ]),
});
